import {useInvalidateQueryCache} from '@aboutyou/data-fetcher';
import {BasketPageService_GetBasketPageBulkLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/service.grpc.lazy';
import {CouponsService_GetWalletV2Lazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coupons/v1/wallet/service.grpc.lazy';
import {WalletService_GetWalletLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wallet/v1/page/service.grpc.lazy';
import {WishlistPageService_GetWishlistPageLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wishlist/v1/page/service.grpc.lazy';
import {useTranslation} from '@aboutyou/i18n';
import {
  useIsArticleDetailPage,
  useIsBasketPage,
  useIsWishlistPage,
} from '@aboutyou/router';
import {Text, useShowToast} from '@aboutyou/ui-components';
import React, {useCallback} from 'react';
import {useWalletStateManager} from '../Wallet/utils/useWalletStateManager';

const useShowCouponsExpiredToast = () => {
  const showToast = useShowToast();
  const {t} = useTranslation();

  const isAdp = useIsArticleDetailPage();
  const isBasket = useIsBasketPage();
  const isWishlist = useIsWishlistPage();
  const {isOpen: isWalletOpen} = useWalletStateManager();
  const shouldShowToast = !isWalletOpen && (isAdp || isBasket || isWishlist);

  return useCallback(() => {
    if (!shouldShowToast) {
      return;
    }

    showToast({
      type: 'WARNING',
      content: (
        <>
          <Text>{t('Oh no! Your coupon has expired.')}</Text>
          <Text>
            {t('We have updated the prices of the items in your basket.')}
          </Text>
        </>
      ),
    });
  }, [t, showToast, shouldShowToast]);
};

export const useInvalidateRequests = () => {
  const {invalidateRequests} = useInvalidateQueryCache();
  const showCouponsExpiredToast = useShowCouponsExpiredToast();

  return useCallback(() => {
    invalidateRequests([
      CouponsService_GetWalletV2Lazy.method,
      WalletService_GetWalletLazy.method,
      BasketPageService_GetBasketPageBulkLazy.method,
      WishlistPageService_GetWishlistPageLazy.method,
    ]);

    showCouponsExpiredToast();
  }, [invalidateRequests, showCouponsExpiredToast]);
};
